import type { ReceivablesAgingDTO } from "../models/receivablesAgingDto";
import type { ReceivablesAgingEntity } from "../../domain/entities/ReceivablesAgingEntity";

export function receivablesAgingDtoToEntity(
  dto: ReceivablesAgingDTO
): ReceivablesAgingEntity {
  return {
    totalOutstandingAmount: Number(dto.totalOutstandingAmount) ?? 0,
    overdueAmount: Number(dto.overdueAmount) ?? 0,
    notOverdueAmount: Number(dto.notOverdueAmount) ?? 0,
    currencySymbol: dto.currencySymbol ?? "₹",
    buckets: (dto.buckets ?? []).map((b) => ({
      label: b.label ?? "",
      amount: Number(b.amount) ?? 0,
      percent: Number(b.percent) ?? 0,
    })),
    alertMessage: dto.alertMessage ?? null,
    asOfDate: typeof dto.asOfDate === "string" ? dto.asOfDate : "",
  };
}
